import React, { Component } from "react";
import "./App.css";
import Simplify360Chat from "./Simplify360Chat/Simplify360Chat";
// import HWLogsDisplay from "./Simplify360Chat/HWLibrary/HWLogsDisplay";
import { s360ConfigService } from "./Simplify360Chat/Services/S360Config";
import {
  watchForChatSDKEvents,
  fetchConfigDetailsFromClientHost,
  checkChangeInConfig,
  loadLocalUser,
} from "./Simplify360Chat/Services/HWIframeBridge";

//version 1.0 uat-prod
import { CometdDService, addConnectionLostListener, reConnectCometd } from "./cometD/cometD-service";

class App extends Component {
  constructor(props) {
    super(props);
    this.appRef = React.createRef();
    this.state = {
      user: null,
      chatMaximized: false,
    };
    //this is to retain values needed from localstorage
    // var lang = localStorage?.getItem('selectedLanguage') && localStorage?.getItem('selectedLanguage');
    localStorage.clear();
    // localStorage.setItem('selectedLanguage',JSON.stringify(lang));

    s360ConfigService.loadClientConfigFromToken();
    watchForChatSDKEvents(this, () => { });
  }
  onConnectionLost() {
 addConnectionLostListener()
  }
  onConnectionOnline() {
    addConnectionLostListener();
  }
  componentDidMount() {
    loadLocalUser();
    //STEP 1
    fetchConfigDetailsFromClientHost();
    localStorage.removeItem("subscribed");
    checkChangeInConfig();
    window.addEventListener("offline", this.onConnectionLost);

    window.addEventListener("online", this.onConnectionOnline);
    // document.addEventListener("visibilitychange", () => {
    //   if (document.visibilityState === "visible") {
    //     reConnectCometd()
    //   } else {
    //     // do nothing
    //   }
    // });
  }
  componentWillUnmount() {
    window.removeEventListener('offline', this.onConnectionLost)
    window.removeEventListener('online',this.onConnectionOnline)
  }
  configureCometd = function (channel, refElement) {
    console.log(channel, refElement, "CALLED COMETD FUNCTION IN APP");
    CometdDService(
      refElement,
      channel //client channel recieved from login
    );
  };

  render() {
    //STEP 9 HERE BY NOW WE GOT CONFIG IN S360CONFIGSERVICE.JS FROM WHERE WE CAN ACCESS CONFIG FROM ALL REACT COMPONENTS
    return (
      <>
        <div ref={this.appRef} id="App">
          {/* <HWLogsDisplay/>  */}
          {/* {console.log("in APP -->",this.state)} */}
          {/* iframe code here */}
          {s360ConfigService.isConfigured() && (
            <Simplify360Chat
              user={this.state.user}
              {...this.state}
              configureCometd={this.configureCometd}
              appRef={this.appRef}
              chatMaximized={this.state.chatMaximized}
            />
          )}
        </div>
      </>
    );
  }
}

export default App;
